import { useCallback, useEffect, useRef } from 'react';

/**
 * Tracks saves that were edited but not yet sent. On unmount (e.g. accordion
 * collapse), runs all pending saves so edits are not lost.
 */
export function usePendingSaveOnUnmount(): {
  track: (key: string, run: () => void) => void;
  persistNow: (key: string, run: () => void) => void;
} {
  const pendingRef = useRef<Map<string, () => void>>(new Map());

  const track = useCallback((key: string, run: () => void) => {
    pendingRef.current.set(key, run);
  }, []);

  const persistNow = useCallback((key: string, run: () => void) => {
    pendingRef.current.delete(key);
    run();
  }, []);

  useEffect(() => {
    const pending = pendingRef.current;
    return () => {
      pending.forEach((run) => run());
      pending.clear();
    };
  }, []);

  return { track, persistNow };
}
